import React, { Component } from "react";
import { CardBody, Button } from "reactstrap";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Row,
  Col
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";

const MetaContent = ({ languages, tabId }: any) => {
  return (
    <TabPane tabId={tabId}>
      <Row>
        <Col sm="12">
          <Card key={languages.id}>
            <CardBody>
              {/* <b>{languages.language}</b> */}
              <AvForm className="sypal-form">
                <AvField
                  name={"licenceTypeMetas.name" + tabId}
                  label="Display name"
                  value={languages.name}
                />
                <div className="sypal-input">
                  <span>Description</span>
                  <textarea
                    name={"licenceTypeMetas.description" + tabId}
                    className="sypal-input"
                    defaultValue={languages.description}
                  />
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </TabPane>
  );
};

class LicenceLanguages extends Component<
  { languages: any; onLanguageChange: any },
  any
> {
  constructor(props: any) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      descriptionCS: this.props.languages[0].description,
      descriptionEN: this.props.languages[1].description,
      nameCS: this.props.languages[0].name,
      nameEN: this.props.languages[1].name
    };

    this.updateLanguages = this.updateLanguages.bind(this);
    this.onDescriptionChangeCS = this.onDescriptionChangeCS.bind(this);
    this.onDescriptionChangeEN = this.onDescriptionChangeEN.bind(this);
    this.onNameChangeCS = this.onNameChangeCS.bind(this);
    this.onNameChangeEN = this.onNameChangeEN.bind(this);
  }

  toggle(tab: any) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  componentDidMount() {
    this.updateLanguages();
  }

  language(lang: any) {
    const { t } = this.props;

    if (lang == "en") {
      return t('translations.english');
    } else if (lang == "cs") {
      return t('translations.czech');
    } else return "Undefined language";
  }

  onDescriptionChangeCS(event: any) {
    this.setState({ descriptionCS: event.target.value }, this.updateLanguages);
  }

  onDescriptionChangeEN(event: any) {
    this.setState({ descriptionEN: event.target.value }, this.updateLanguages);
  }

  onNameChangeCS(event: any) {
    this.setState({ nameCS: event.target.value }, this.updateLanguages);
  }

  onNameChangeEN(event: any) {
    this.setState({ nameEN: event.target.value }, this.updateLanguages);
  }

  updateLanguages() {
    let lang = [];
    if(this.props.languages[0].id){
      lang[0] = {
        id: this.props.languages[0].id,
        language: this.props.languages[0].language,
        licenceTypeId: this.props.languages[0].licenceTypeId,
        name: this.state.nameCS,
        description: this.state.descriptionCS
      };
    }else{
      lang[0] = {
        language: this.props.languages[0].language,
        licenceTypeId: this.props.languages[0].licenceTypeId,
        name: this.state.nameCS,
        description: this.state.descriptionCS
      };
    }

    if(this.props.languages[0].id){
      lang[1] = {
        id: this.props.languages[1].id,
        language: this.props.languages[1].language,
        licenceTypeId: this.props.languages[1].licenceTypeId,
        name: this.state.nameEN,
        description: this.state.descriptionEN
      };
    }else{
      lang[1] = {
        language: this.props.languages[1].language,
        licenceTypeId: this.props.languages[1].licenceTypeId,
        name: this.state.nameEN,
        description: this.state.descriptionEN
      };
    }

    this.props.onLanguageChange(lang);
  }

  render() {
    const { t } = this.props;

    return (
      <div style={{ paddingBottom: "30px" }}>
        <Nav tabs style={{ border: "none" }}>
          <NavItem>
            <NavLink
              className={this.state.activeTab == "1" ? "active" : ""}
              onClick={() => {
                this.toggle("1");
              }}
            >
              {this.language(this.props.languages[0].language)}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.activeTab == "2" ? "active" : ""}
              onClick={() => {
                this.toggle("2");
              }}
            >
              {this.language(this.props.languages[1].language)}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Card key={this.props.languages[0].id}>
                  <CardBody>
                    <AvForm className="sypal-form">
                      <AvField
                        name="nameEN"
                        label={t('translations.display_name')}
                        value={this.props.languages[0].name}
                        onChange={this.onNameChangeCS}
                      />

                      <div className="sypal-input">
                        <span>{t('translations.description')}</span>
                        <textarea
                          name="licenceTypeMetas[0].description"
                          className="sypal-input"
                          defaultValue={this.props.languages[0].description}
                          onChange={this.onDescriptionChangeCS}
                        />
                      </div>

                      <div style={{ display: "none" }}>
                        <AvField
                          name="descriptionCS"
                          value={this.state.descriptionCS}
                        />
                        <AvField name="nameCS" value={this.state.nameCS} />
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>

          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <Card key={this.props.languages[1].id}>
                  <CardBody>
                    <AvForm className="sypal-form">
                      <AvField
                        name="nameCS"
                        label={t('translations.display_name')}
                        value={this.props.languages[1].name}
                        onChange={this.onNameChangeEN}
                      />
                      <div className="sypal-input">
                        <span>{t('translations.description')}</span>
                        <textarea
                          name="licenceTypeMetas[1].description"
                          className="sypal-input"
                          defaultValue={this.props.languages[1].description}
                          onChange={this.onDescriptionChangeEN}
                        />
                      </div>
                      <div style={{ display: "none" }}>
                        <AvField
                          name="desctiptionEN"
                          value={this.state.descriptionEN}
                        />
                        <AvField name="nameEN" value={this.state.nameEN} />
                      </div>
                    </AvForm>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const TranslatedLanguagesComponent = withTranslation('licences')(LicenceLanguages);

export { TranslatedLanguagesComponent as LicenceLanguages };